// Map device type code to brand display name, based on provided enum mapping
const brandNameMap: Record<number, string> = {
  0: "Empty",
  1: "Auxiliary",
  2: "Pool Heater",
  3: "Pressure Cleaner",
  4: "In Floor Cleaning",
  5: "Salt Chlorinator",
  6: "pH Doser",
  7: "Mineral Chlorinator",
  8: "Liquid Chlorine",
  9: "Naked Inoiser",
  10: "Ozone",
  11: "UV",
  12: "Astral Pool Light",
  13: "Aquaquip Pool Light",
  14: "Poolrite  Pool Light",
  15: "SPA Electrics Pool Light",
  16: "ZODIAC Pool Light",
  17: "Solar Dedicated",
  18: "Solar Filter Pump",
  19: "Spa Heater",
  20: "Spa Actuator Return",
  21: "Spa Actuator Suction",
  22: "Spa Jet",
  23: "Spa Jet",
  24: "Spa Blower",
  25: "Spa Blower",
  26: "Astral Spa Pool Light",
  27: "Aquaquip Spa Pool Light",
  28: "Poolrite Spa Pool Light",
  29: "SPA Electrics Spa Pool Light",
  30: "Zodiac Spa Light",
  31: "Main Pump",
  32: "Spa & Pool Heater",
  33: "Spa Actuator Extra 1",
  34: "Spa Actuator Extra 2",
  35: "PAL Lighting",
  36: "SPA PAL Lighting",
  999: "Mineral Swim V2",
};

export function getBrandNameByType(typeCode?: number): string {
  if (typeCode === undefined || typeCode === null) return "Unknown";
  return brandNameMap[typeCode] ?? "Unknown";
}

export default getBrandNameByType;
